import template from './analytics-marketing.html';
import controller from './analytics-marketing.controller';
import './analytics-marketing.styl';

let analyticsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default analyticsComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/analytics-marketing/analytics-marketing.component.js
 **/